/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for FileResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, FileDTO } from "../models";

@Injectable({ providedIn: "root" })
export class FileResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    uploadPdf(plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<FileDTO>;
    uploadPdf(plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<FileDTO>>;
    uploadPdf(plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<FileDTO>>;
    uploadPdf(plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/uploadPdf`;

        let params = new HttpParams();
        if (plaquetteFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, plaquetteFormat, 'plaquetteFormat');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    uploadLogoPlaquettes(logoFormat: string, plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<FileDTO>;
    uploadLogoPlaquettes(logoFormat: string, plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<FileDTO>>;
    uploadLogoPlaquettes(logoFormat: string, plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<FileDTO>>;
    uploadLogoPlaquettes(logoFormat: string, plaquetteFormat: string, requestBody?: Record<string, any>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/uploadLogoPlaquettes`;

        let params = new HttpParams();
        if (logoFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, logoFormat, 'logoFormat');
        }
        if (plaquetteFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, plaquetteFormat, 'plaquetteFormat');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    uploadLogoIes(logoFormat: string, requestBody?: Record<string, any>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<FileDTO>;
    uploadLogoIes(logoFormat: string, requestBody?: Record<string, any>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<FileDTO>>;
    uploadLogoIes(logoFormat: string, requestBody?: Record<string, any>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<FileDTO>>;
    uploadLogoIes(logoFormat: string, requestBody?: Record<string, any>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/uploadLogoIes`;

        let params = new HttpParams();
        if (logoFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, logoFormat, 'logoFormat');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    uploadExtension(extensionFormat: string, requestBody?: Record<string, any>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<FileDTO>;
    uploadExtension(extensionFormat: string, requestBody?: Record<string, any>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<FileDTO>>;
    uploadExtension(extensionFormat: string, requestBody?: Record<string, any>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<FileDTO>>;
    uploadExtension(extensionFormat: string, requestBody?: Record<string, any>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/upload-extension`;

        let params = new HttpParams();
        if (extensionFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, extensionFormat, 'extensionFormat');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    uploadAgrementProvisoire(agrementProvisoireFormat: string, requestBody?: Record<string, any>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<FileDTO>;
    uploadAgrementProvisoire(agrementProvisoireFormat: string, requestBody?: Record<string, any>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<FileDTO>>;
    uploadAgrementProvisoire(agrementProvisoireFormat: string, requestBody?: Record<string, any>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<FileDTO>>;
    uploadAgrementProvisoire(agrementProvisoireFormat: string, requestBody?: Record<string, any>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/upload-agrement-provisoire`;

        let params = new HttpParams();
        if (agrementProvisoireFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, agrementProvisoireFormat, 'agrementProvisoireFormat');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    uploadAgrementDefinitif(agrementDefinitifFormat: string, requestBody?: Record<string, any>, observe?: 'body', options?: RequestOptions<'blob'>): Observable<FileDTO>;
    uploadAgrementDefinitif(agrementDefinitifFormat: string, requestBody?: Record<string, any>, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<FileDTO>>;
    uploadAgrementDefinitif(agrementDefinitifFormat: string, requestBody?: Record<string, any>, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<FileDTO>>;
    uploadAgrementDefinitif(agrementDefinitifFormat: string, requestBody?: Record<string, any>, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/upload-agrement-definitif`;

        let params = new HttpParams();
        if (agrementDefinitifFormat != null) {
            params = HttpParamsBuilder.addToHttpParams(params, agrementDefinitifFormat, 'agrementDefinitifFormat');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: requestBody,
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getPlaquette(plaquette: string, sigle?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<string>;
    getPlaquette(plaquette: string, sigle?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<string>>;
    getPlaquette(plaquette: string, sigle?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<string>>;
    getPlaquette(plaquette: string, sigle?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/getplaquette`;

        let params = new HttpParams();
        if (plaquette != null) {
            params = HttpParamsBuilder.addToHttpParams(params, plaquette, 'plaquette');
        }
        if (sigle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, sigle, 'sigle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getLogoIes(logo: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<string>;
    getLogoIes(logo: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<string>>;
    getLogoIes(logo: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<string>>;
    getLogoIes(logo: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/get-logo-ies`;

        let params = new HttpParams();
        if (logo != null) {
            params = HttpParamsBuilder.addToHttpParams(params, logo, 'logo');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getLogoEtablissement(logo: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<string>;
    getLogoEtablissement(logo: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<string>>;
    getLogoEtablissement(logo: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<string>>;
    getLogoEtablissement(logo: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/get-logo-etablissement`;

        let params = new HttpParams();
        if (logo != null) {
            params = HttpParamsBuilder.addToHttpParams(params, logo, 'logo');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getExtension(extension: string, nomFichier?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<string>;
    getExtension(extension: string, nomFichier?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<string>>;
    getExtension(extension: string, nomFichier?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<string>>;
    getExtension(extension: string, nomFichier?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/get-extension`;

        let params = new HttpParams();
        if (extension != null) {
            params = HttpParamsBuilder.addToHttpParams(params, extension, 'extension');
        }
        if (nomFichier != null) {
            params = HttpParamsBuilder.addToHttpParams(params, nomFichier, 'nomFichier');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAgrementProvisoire(agrementProvisoire: string, sigle?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<string>;
    getAgrementProvisoire(agrementProvisoire: string, sigle?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<string>>;
    getAgrementProvisoire(agrementProvisoire: string, sigle?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<string>>;
    getAgrementProvisoire(agrementProvisoire: string, sigle?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/get-agrement-provisoire`;

        let params = new HttpParams();
        if (agrementProvisoire != null) {
            params = HttpParamsBuilder.addToHttpParams(params, agrementProvisoire, 'agrementProvisoire');
        }
        if (sigle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, sigle, 'sigle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    getAgrementDefinitif(agrementDefinitif: string, sigle?: string, observe?: 'body', options?: RequestOptions<'blob'>): Observable<string>;
    getAgrementDefinitif(agrementDefinitif: string, sigle?: string, observe?: 'response', options?: RequestOptions<'blob'>): Observable<HttpResponse<string>>;
    getAgrementDefinitif(agrementDefinitif: string, sigle?: string, observe?: 'events', options?: RequestOptions<'blob'>): Observable<HttpEvent<string>>;
    getAgrementDefinitif(agrementDefinitif: string, sigle?: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/get-agrement-definitif`;

        let params = new HttpParams();
        if (agrementDefinitif != null) {
            params = HttpParamsBuilder.addToHttpParams(params, agrementDefinitif, 'agrementDefinitif');
        }
        if (sigle != null) {
            params = HttpParamsBuilder.addToHttpParams(params, sigle, 'sigle');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', '*/*');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            responseType: 'blob',
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
